export function createCancellationToken(isCancelled = false) {
  return {
    isCancelled
  };
}